/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  DutyRosterReleaseWorkflowDto,
  GetDutyRosterReleaseWorkflowsParams
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getGetDutyRosterReleaseWorkflowsUrl = (params?: GetDutyRosterReleaseWorkflowsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/DutyRosterReleaseWorkflow/GetDutyRosterReleaseWorkflows?${stringifiedParams}` : `/api/DutyRosterReleaseWorkflow/GetDutyRosterReleaseWorkflows`
}

export const getDutyRosterReleaseWorkflows = async (params?: GetDutyRosterReleaseWorkflowsParams, options?: RequestInit): Promise<DutyRosterReleaseWorkflowDto[]> => {
  
  return customInstance<DutyRosterReleaseWorkflowDto[]>(getGetDutyRosterReleaseWorkflowsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetDutyRosterReleaseWorkflowsQueryKey = (params?: GetDutyRosterReleaseWorkflowsParams,) => {
    return [
    `/api/DutyRosterReleaseWorkflow/GetDutyRosterReleaseWorkflows`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetDutyRosterReleaseWorkflowsQueryOptions = <TData = Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError = ErrorType<unknown>>(params?: GetDutyRosterReleaseWorkflowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDutyRosterReleaseWorkflowsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>> = ({ signal }) => getDutyRosterReleaseWorkflows(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDutyRosterReleaseWorkflowsQueryResult = NonNullable<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>>
export type GetDutyRosterReleaseWorkflowsQueryError = ErrorType<unknown>


export function useGetDutyRosterReleaseWorkflows<TData = Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError = ErrorType<unknown>>(
 params: undefined |  GetDutyRosterReleaseWorkflowsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>,
          TError,
          Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDutyRosterReleaseWorkflows<TData = Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError = ErrorType<unknown>>(
 params?: GetDutyRosterReleaseWorkflowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>,
          TError,
          Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDutyRosterReleaseWorkflows<TData = Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError = ErrorType<unknown>>(
 params?: GetDutyRosterReleaseWorkflowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDutyRosterReleaseWorkflows<TData = Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError = ErrorType<unknown>>(
 params?: GetDutyRosterReleaseWorkflowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDutyRosterReleaseWorkflowsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetDutyRosterReleaseWorkflowsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError = ErrorType<unknown>>(params?: GetDutyRosterReleaseWorkflowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDutyRosterReleaseWorkflowsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>> = ({ signal }) => getDutyRosterReleaseWorkflows(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDutyRosterReleaseWorkflowsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>>
export type GetDutyRosterReleaseWorkflowsSuspenseQueryError = ErrorType<unknown>


export function useGetDutyRosterReleaseWorkflowsSuspense<TData = Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError = ErrorType<unknown>>(
 params: undefined |  GetDutyRosterReleaseWorkflowsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDutyRosterReleaseWorkflowsSuspense<TData = Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError = ErrorType<unknown>>(
 params?: GetDutyRosterReleaseWorkflowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDutyRosterReleaseWorkflowsSuspense<TData = Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError = ErrorType<unknown>>(
 params?: GetDutyRosterReleaseWorkflowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDutyRosterReleaseWorkflowsSuspense<TData = Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError = ErrorType<unknown>>(
 params?: GetDutyRosterReleaseWorkflowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDutyRosterReleaseWorkflowsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



